import React, { useState, useEffect } from 'react';
import { ReactComponent as DropdownTransparent } from '../assets/svg/DropdownTransparent.svg';

function SelectStringComponent({
	value = '',
	setValue,
	width = 180,
	height = 40,
	options = ['Srpski', 'English'],
	selectedOption = 'Select language',
	isCapitalize = false,
}: {
	value: string;
	setValue: any;
	width?: number;
	height?: number;
	options?: string[];
	selectedOption?: string;
	isCapitalize?: boolean;
}) {
	const [showDropdown, setShowDropdown] = useState(false);
	const [option, setOption] = useState(selectedOption);

	useEffect(() => {
		setOption(selectedOption);
	}, [selectedOption]);

	const handleSelection = (item: string) => {
		setOption(item);
		setValue(item);
		setShowDropdown(false);
	};

	return (
		<div className={`relative flex flex-col`}>
			<div
				className={`z-[6] flex cursor-pointer  flex-row items-center justify-between rounded-[25px]  ${showDropdown ? 'px-[15px]' : 'border border-primaryViolet px-[14px]'}   `}
				style={{ width, height }}
				onClick={(e) => {
					e.preventDefault();
					setShowDropdown(!showDropdown);
				}}
			>
				<p className={`text-[18px] font-semibold leading-5 text-primaryViolet ${isCapitalize ? 'capitalize' : ''} transition`}>{option}</p>
				<div className={`${showDropdown ? 'rotate-180' : 'rotate-0'} transition`}>
					<DropdownTransparent style={{ color: '#5E639B' }} />
				</div>
			</div>
			{showDropdown && (
				<div
					className={`absolute top-0 z-[5] flex flex-1 flex-col rounded-[25px] bg-white   shadow-md ${showDropdown ? 'border border-primaryViolet' : ''}`}
					style={{ width, paddingTop: height + 5 }}
				>
					<div className='blue-small-scroll mb-3 max-h-[150px] w-full  overflow-auto'>
						{options.map((item: string, index: number) => (
							<p
								className={`mb-[6px] cursor-pointer px-[15px] text-[18px] font-semibold leading-5 text-primaryViolet transition duration-200 hover:text-darkenPurple ${
									isCapitalize ? 'capitalize' : ''
								}`}
								onClick={() => handleSelection(item)}
								key={index}
							>
								{item}
							</p>
						))}
					</div>
				</div>
			)}
		</div>
	);
}

export default SelectStringComponent;
